/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const InvoiceBody = styled.div`
	min-height: 100vh;
	min-height: 100dvh;
	/* Window scroll for tall checkout (Stripe) — avoid a fixed viewport + inner scroll trap */
	overflow-x: hidden;
	overflow-y: visible;
	background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
	display: flex;
	flex-direction: column;
	align-items: stretch;
	width: 100%;
	box-sizing: border-box;
	padding: 20px 16px 4px;

	@media (max-width: 480px) {
		/* Mobile: white page, no floating card over grey background. */
		background: #ffffff;
		padding: 0;
		min-height: 100vh;
		min-height: 100dvh;
	}
`;

/** Main column grows with content; user scrolls the page, not a nested panel. */
export const InvoiceMainRegion = styled.div`
	flex: 0 0 auto;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	width: 100%;
	overflow: visible;

	@media (max-width: 480px) {
		/* Push branding to the bottom while avoiding extra page scroll. */
		flex: 1 1 0;
	}
`;

export const InvoiceContainer = styled.div`
	width: 600px;
	background: #ffffff;
	border-radius: 20px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
	padding: 32px 32px;
	/* Grow with tall checkout (Stripe + hints); never clip inner content */
	max-height: none;
	overflow: visible;

	& > :last-child {
		margin-bottom: 0;
	}

	@media (max-width: 480px) {
		width: 100%;
		border-radius: 0;
		padding: 18px 16px;
		box-shadow: none;
		margin: 0;
		background: #ffffff;
		/* Don't force 100vh: otherwise the branding link gets pushed below view. */
		min-height: auto;
	}
`;

export const LogoContainer = styled.div`
	width: 100%;
	height: 80px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 24px;

	@media (max-width: 480px) {
		height: 64px;
		margin-bottom: 20px;
		margin-top: 0;
		padding-top: 0;
	}
`;

export const Logo = styled.div`
	width: ${(props) => (props.hasImage ? '80px' : '0px')};
	height: ${(props) => (props.hasImage ? '80px' : '0px')};
	background-size: contain;
	background-position: center center;
	background-repeat: no-repeat;
	border-radius: 16px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	margin: 0 auto 24px;

	@media (max-width: 480px) {
		width: ${(props) => (props.hasImage ? '64px' : '0px')};
		height: ${(props) => (props.hasImage ? '64px' : '0px')};
		border-radius: 14px;
		box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
		margin-bottom: 20px;
	}
`;

export const TopSection = styled.div`
	margin-bottom: 24px;
	text-align: center;

	@media (max-width: 480px) {
		margin-bottom: 16px;
		margin-top: 0;
		padding: 0 24px;
	}

	@media (max-width: 360px) {
		padding: 0 20px;
	}
`;

export const BusinessName = styled.div`
	font-size: 24px;
	font-weight: 700;
	color: #1a1a1a;
	margin-bottom: 4px;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

	@media (max-width: 480px) {
		font-size: 22px;
		margin-bottom: 4px;
		font-weight: 600;
	}

	@media (max-width: 360px) {
		font-size: 20px;
	}
`;

export const Address = styled.div`
	font-size: 14px;
	color: #6b7280;
	line-height: 1.5;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

	@media (max-width: 480px) {
		font-size: 13px;
		line-height: 1.4;
		color: #64748b;
	}
`;

export const MiddleSection = styled.div`
	margin-bottom: 32px;
	text-align: center;

	@media (max-width: 480px) {
		margin-bottom: 28px;
		padding: 0 24px;
	}

	@media (max-width: 360px) {
		padding: 0 20px;
	}
`;

export const Amount = styled.div`
	font-size: 48px;
	color: #1a1a1a;
	font-weight: 700;
	letter-spacing: -0.02rem;
	line-height: 1.1;
	margin-bottom: 10px;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

	@media (max-width: 480px) {
		font-size: 42px;
		margin-bottom: 10px;
		color: #1a1a1a;
	}

	@media (max-width: 360px) {
		font-size: 38px;
	}
`;

export const TotalAmount = styled.div`
	font-size: 16px;
	color: #374151;
	font-weight: 500;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 6px;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

	@media (max-width: 480px) {
		font-size: 15px;
		margin-bottom: 4px;
		color: #475569;
	}
`;

export const ConvenienceFee = styled.div`
	font-size: 16px;
	color: #374151;
	font-weight: 500;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 16px;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

	@media (max-width: 480px) {
		font-size: 15px;
		margin-bottom: 14px;
		color: #475569;
	}
`;

export const Date = styled.div`
	font-size: 13px;
	color: #475569;
	font-weight: 600;
	margin-bottom: 6px;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
	letter-spacing: 0.01em;

	@media (max-width: 480px) {
		font-size: 12px;
		margin-bottom: 4px;
		color: #64748b;
	}
`;

export const Description = styled.div`
	font-size: 15px;
	color: #64748b;
	line-height: 1.5;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

	@media (max-width: 480px) {
		font-size: 14px;
		line-height: 1.4;
		color: #64748b;
	}
`;

export const PaymentSuccess = styled.div`
	font-size: 16px;
	color: #059669;
	font-weight: 500;
	text-align: center;
	margin-bottom: 16px;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

	@media (max-width: 480px) {
		font-size: 15px;
		margin-bottom: 14px;
	}
`;

export const BottomSection = styled.div`
	margin-top: 8px;

	@media (max-width: 480px) {
		margin-top: 6px;
		padding: 0 24px;
	}

	@media (max-width: 360px) {
		padding: 0 20px;
	}
`;

/**
 * Reserves stable vertical space so the card doesn't resize between Pay by card, the
 * card form, and success. Sized to the tallest state: the card form with its reserved
 * error line (success banner + receipt button is ~134px).
 */
export const CheckoutActionSlot = styled.div`
	min-height: 146px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	overflow: visible;

	@media (max-width: 480px) {
		min-height: 0;
	}
`;

export const Branding = styled.a`
	flex-shrink: 0;
	align-self: center;
	text-align: center;
	font-size: 12px;
	padding: 6px 8px 2px;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
	text-decoration: none;
	transition: color 0.2s ease;

	&:hover {
		color: #6b7280;
	}

	@media (max-width: 480px) {
		font-size: 11px;
		color: #94a3b8;
		padding: 10px 24px 12px;
	}

	@media (max-width: 360px) {
		padding: 8px 20px 10px;
	}
`;

export const ModernDivider = styled.div`
	height: 1px;
	background: linear-gradient(
		90deg,
		transparent 0%,
		#e2e8f0 50%,
		transparent 100%
	);
	margin: 20px 0;

	@media (max-width: 480px) {
		margin: 14px 0;
		background: #e2e8f0;
	}
`;

export const PaymentDetailsBox = styled.div`
	background: transparent;
	border: 0;
	border-radius: 0;
	padding: 0;
	margin-bottom: 14px;

	@media (max-width: 480px) {
		padding: 0;
		margin-bottom: 10px;
	}
`;
